import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS, TRANSACTION_TYPE_OPTIONS } from '../../data/constants';

/**
 * Hook to fetch transaction types
 */
export const useTransactions = () =>
  useQuery({
    queryKey: [QUERY_KEYS.TRANSACTION_TYPES],
    queryFn: () => TRANSACTION_TYPE_OPTIONS,
    staleTime: Infinity,
  });
